require('../../modules/es6.string.from-code-point');
module.exports = require('../../modules/_core').String.fromCodePoint;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/string/from-code-point.js
// module id = 538
// module chunks = 158